import { useDispatch, useSelector } from 'react-redux'
import type { PositionDispatch, RootState } from './types'

export const useAccountsDispatch = () => useDispatch<PositionDispatch>()
export const useAccountsSelector = useSelector.withTypes<RootState>()
